import { useAuth0 } from '@auth0/auth0-react';
import { css, jsx } from '@emotion/core';
import Router, { useRouter } from 'next/router';
import React from 'react';
import { useSelector } from 'react-redux';

import LoadingPage from '../LoadingPage/LoadingPage';

const style = {
  loadingPage: css`
    height: 100vh;
    width: 100vw;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

function withAuthentication(Component) {
  function NewComponent(props) {
    const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();
    const { pathname } = useRouter();
    const stateLoading = useSelector(state => state.auth.isLoading);

    if (isLoading || stateLoading) {
      return (
        <div css={style.loadingPage}>
          <LoadingPage />
        </div>
      );
    }

    if (!isLoading && !stateLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
      return null;
    }

    return <Component {...props} />;
  }

  return NewComponent;
}

export default withAuthentication;
